module.exports = __webpack_public_path__ + "media/images/lb/787-18396f8d1a89c2450d975aa8493d64bd.svg";